import React from 'react'
import Modal from 'pubweb-smokey/dist/components/Modal/Modal'

const LearnModal = ({article, onLearnModalClose}) => {
    console.log(article.url)
    return (
        <Modal
            onClose={() => onLearnModalClose()}
        >
            <div className="nav-hider">&nbsp;</div>
            <button onClick={() => onLearnModalClose()}>close</button>
            <iframe width="100%" height="100%" src={article.url} title={article.heading}></iframe>
        </Modal>

    )
}

export default LearnModal;
